module.exports = __webpack_public_path__ + "img/botswana.8989c8a8.svg";